import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllCity,
  GetCity,
  UpdateCity,
} from "../../../../../../../features/admin/masters/city/Slice";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import {
  AllCountry,
  AllState,
} from "../../../../../../../features/admin/common/Slice";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);

  const handleCountryChange = async (selectedOption) => {
    setValue("country_id", selectedOption);
    setValue("state_id", null); // Reset state when changing country
    dispatch(AllState({ countryId: selectedOption.value })); // Fetch states for the selected country
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => {
    if (defaultValues?.country_id?.value) {
      dispatch(AllState(defaultValues.country_id.value));
    } else {
      setValue("state_id", null); // Clear state if no country
    }
    reset(defaultValues);
  }, [defaultValues, reset, dispatch]);

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(UpdateCity({ id: data.id, data }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAllCity());

        setModalsuccessShow(true); // ✅ SHOW SUCCESS MODAL
        setShow(false); // close offcanvas
        setSuccess(true); // optional
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetCity(id));
      const cityData = res?.payload?.data;
      console.log("Fetched City Data:", cityData);
      setDefaultValues(cityData);
      dispatch(AllCountry());

      if (cityData?.country_id) {
        dispatch(AllState(cityData.country_id.value));
      }
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Country Selection Dropdown */}
                <Form.Group className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Controller
                    name="country_id"
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countries}
                        onChange={handleCountryChange}
                        onInputChange={(val) => {
                          dispatch(AllCountry(val));
                        }}
                      />
                    )}
                  />
                  {errors?.country_id && (
                    <Form.Text className="text-danger">
                      {errors?.country_id?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Controller
                    name="state_id"
                    control={control}
                    rules={{ required: "State is required" }}
                    render={({ field }) => {
                      const countryId = getValues("country_id");
                      const isCountrySelected = Boolean(countryId?.value);
                      return (
                        <Select
                          {...field}
                          options={isCountrySelected ? states : []}
                          // isDisabled={!isCountrySelected}
                          onInputChange={(val) => {
                            if (isCountrySelected) {
                              dispatch(
                                AllState({
                                  countryId: countryId.value,
                                  name: val,
                                })
                              );
                            }
                          }}
                        />
                      );
                    }}
                  />
                  {errors?.state_id && (
                    <Form.Text className="text-danger">
                      {errors?.state_id?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
